import AboutLocation from "./AboutLocation";
import AboutPaste from "./AboutFirst";
import AboutSugaring from "./AboutSecond";
import Contact from "./Contact";
import Header from "./Header";

const MainPage = () => {
    return (
        <>
            <Header />
            <AboutPaste />
            <AboutSugaring />
            <AboutLocation />
            <Contact />
        </>
    )
};

export default MainPage;